module.exports = __webpack_public_path__ + "img/Carnaval_LaBase.806515e4.png";